<template>
  <button @click="show" :aria-label="$t('buttons.copy')" :title="$t('buttons.copy')" class="action" id="copy-button">
    <clipboard-icon size="1.5x" class="custom-class"></clipboard-icon>
    <span>{{ $t('buttons.copy') }}</span>
  </button>
</template>

<script>

import { ClipboardIcon } from 'vue-feather-icons';

export default {
  name: 'copy-button',
  components: {
    ClipboardIcon
  },
  methods: {
    show: function () {
      this.$store.commit('showHover', 'copy');
    }
  }
};
</script>
